module.exports = __webpack_public_path__ + "static/media/no_result.d45aa3e7.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/no_result.svg
// module id = 859
// module chunks = 0